import { getUserDetailFromToken } from "services/LocalStorage/LocalStorage.service";
import customAxiosInterceptor from "../customAxiosInterceptor";

// Rate article - lajkuj proizvod ili oceni
// PUT https://api.infocomp.ba/api/article-rate/{slug}
export const rateArticleThunk = async ({ slug, data }, thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.put(
      `/article-rate/${slug}`,
      data
    );
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};

// dobavi lajkovane ili ocenjene proizvode
// GET https://api.infocomp.ba/api/article-rate?order=ASC&page=1&take=10&type=rated
export const fetchRateArticleThunk = async ({ page, take, type }, thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.get(`/article-rate`, {
      params: { page: page, take: take, type: type },
    });
    return { data: response.data.data, meta: response.data.meta, type: type };
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};
